import Vue from 'vue';

// Instance to make html window properties available in reactive manner.
const WindowInstance = new Vue({
    data () {
        return {
            innerWidth: window.innerWidth,
        };
    },
    created () {
        window.addEventListener('resize', e => {
            this.innerWidth = window.innerWidth;
        });
    },
});

export default WindowInstance;
